import {EndComponent} from "../components";

export class EndComponentHelper {

    static getEndNodeInputKey(nodeKey) {
        return `${nodeKey}_${EndComponent.END_COMPONENT_KEY}_${EndComponent.END_INPUT_KEY}`;
    }
}